import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "../pages/Login";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import RootRedirect from "./RootRedirect";
import { APP_ROUTES } from "../constants";
import Chat from "../pages/Chat";
import Hibro from "../pages/Hibro"
import HiCRM from "../pages/HiCRM"
import Unified from "../pages/Unified"

const ProtectedLayout = () => (
  <ProtectedRoute>
    <Outlet />
  </ProtectedRoute>
);
debugger;
const AppRoutes = () => (
  <Routes>
    <Route path={APP_ROUTES.LOGIN} element={<Login />} />
    <Route
      path={APP_ROUTES.FORGOT_PASSWORD}
      element={<div>Forgot Password Page</div>}
    />
    <Route path={APP_ROUTES.HOME} element={<RootRedirect />} />

    <Route element={<ProtectedLayout />}>
      <Route path={APP_ROUTES.CHAT} element={<Chat />} />
    </Route>
        <Route path={APP_ROUTES.Hibro} element={<Hibro />} />
        <Route path={APP_ROUTES.HiCRM} element={<HiCRM />} />
        <Route path={APP_ROUTES.Unified} element={<Unified />} />
    <Route path="*" element={<Navigate to={APP_ROUTES.HOME} replace />} />
  </Routes>
);

export default AppRoutes;
